import { gql } from '../../../__generated__/graphql/catalog/gql'

export const FETCH_EMBROIDERY_PRODUCT_PRICE = gql(`
  query fetchEmbroideryProductPrice(
    $handle: String!
    $colorKey: String!
    $fitKey: String!
    $sizeKey: String
  ) {
    productCatalogStandardProduct(handle: $handle) {
      variantGroup(color: $colorKey) {
        defaultVariant {
          price {
            amount
            currencyCode
          }
          compareAtPrice {
            amount
          }
        }
        variant(fit: $fitKey, size: $sizeKey) {
          price {
            amount
            currencyCode
          }
          compareAtPrice {
            amount
          }
        }
      }
    }
  }
`)
